import { Stack, Text } from "@certn/cascadia";
import { css } from "@emotion/css";

interface Props {
  label?: string;
  value?: string | null;
  isLoading?: boolean;
}

export function SummaryItem(props: Props) {
  const { label, value, isLoading } = props;

  return (
    <Stack gap="space-4" orientation="horizontal" className={styles.item}>
      <Text
        style="global/heading-medium"
        className={styles.label}
        isLoading={isLoading}
      >
        {label}
      </Text>
      <Text style="global/body-primary" color="text-weak" isLoading={isLoading}>
        {value ?? "-"}
      </Text>
    </Stack>
  );
}

const styles = {
  item: css({
    paddingTop: "var(--space-1)",
    paddingBottom: "var(--space-2-5)",
  }),
  label: css({
    width: "160px",
  }),
};
